module.exports = __webpack_public_path__ + "static/media/knexcar.ccf6f16f.png";